import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";
import {  listUserPreference } from "../../graphql";

export const listUserpreferenceApi = createApi({
  reducerPath: "listUserpreference",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    fetchUserpreference: builder.query({
        query: () => ({ body: listUserPreference }),
      keepUnusedDataFor: Infinity,
      refetchOnMountOrArgChange: true,
      providesTags: ["ListUserpreferenceData"],
    }),
  }),
});

export const {
  useFetchUserpreferenceQuery
} = listUserpreferenceApi;
